import { loadingSpinnerActions } from "../../actions/loadingSpinnerActions";
var ProductLinesReduxProps = {
    mapDispatchToProps: function (dispatch) {
        return {
            onShowSpinner: function () { return dispatch({ type: loadingSpinnerActions.SHOW_SPINNER_MODAL }); },
            onHideSpinner: function () { return dispatch({ type: loadingSpinnerActions.HIDE_SPINNER_MODAL }); },
        };
    }
};
export default ProductLinesReduxProps;



//////////////////
// WEBPACK FOOTER
// ./src/views/SuggestionOffers/SuggestionOffersReduxProps.ts
// module id = 485
// module chunks = 0